import { memo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";
import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";

const CareerDetails = memo(
  ({
    overview,
    qualifications,
    keyResponsibilities,
    benefits,
    className = "",
  }) => {
    const { t } = useTranslation("careers");

    return (
      <>
        <section
          className={`w-full self-stretch flex flex-row items-start justify-end px-6 sm:px-6 lg:px-20 py-[40px] lg:py-[60px] box-border text-text-primary max-w-[1600px] mx-auto  ${className}`}
        >
          <div className="w-full box-border self-stretch flex flex-col lg:flex-row items-start justify-start gap-6 md:gap-10 max-w-full shrink-0">
            <div className="w-full lg:w-1/3 flex flex-col items-start justify-start p-0 box-border max-w-full">
              <h2 className="m-0 relative text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] font-medium">
                {t("careers.overview")}
              </h2>
            </div>
            <div
              className="w-full flex-1 relative text-[16px] leading-[150%] inline-block max-w-full"
              dangerouslySetInnerHTML={{
                __html: addDofollowToAnchors(overview) || "",
              }}
            />
          </div>
        </section>
        <section
          className={`w-full self-stretch flex flex-row items-start justify-end px-6 sm:px-6 lg:px-20 pb-[40px] lg:pb-[60px] box-border text-text-primary max-w-[1600px] mx-auto  ${className}`}
        >
          <div className="w-full box-border self-stretch flex flex-col lg:flex-row items-start justify-start gap-6 md:gap-10 max-w-full shrink-0">
            <div className="w-full lg:w-1/3 flex flex-col items-start justify-start p-0 box-border max-w-full">
              <h2 className="m-0 relative text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] font-medium">
                {t("careers.qualifications")}
              </h2>
            </div>
            <div className="w-full flex-1 relative text-[16px] leading-[150%] inline-block max-w-full">
              <ul className="m-0 flex flex-col items-start justify-start gap-3 w-full box-border">
                {qualifications?.map((item, i) => (
                  <li
                    key={i}
                    className="w-full  relative text-[16px] leading-[150%] text-start wrapListIem"
                    dangerouslySetInnerHTML={{
                      __html: addDofollowToAnchors(item) || "",
                    }}
                  />
                  //   {item}
                  // </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
        <section
          className={`w-full self-stretch flex flex-row items-start justify-end px-6 sm:px-6 lg:px-20 pb-[40px] lg:pb-[60px] box-border text-text-primary max-w-[1600px] mx-auto  ${className}`}
        >
          <div className="w-full self-stretch flex flex-col lg:flex-row items-start justify-start gap-6 md:gap-10 max-w-full shrink-0">
            <div className="w-full lg:w-1/3 flex flex-col items-start justify-start p-0 box-border max-w-full">
              <h2 className="m-0 relative text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] font-medium">
                {t("careers.keyResponsibilities")}
              </h2>
            </div>
            <div className="w-full flex-1 relative text-[16px] leading-[150%] inline-block max-w-full">
              <ul className="m-0 flex flex-col items-start justify-start gap-3 w-full box-border">
                {keyResponsibilities?.map((item, i) => (
                  <li
                    key={i}
                    className="w-full relative text-[16px] leading-[150%] text-start wrapListIem"
                    dangerouslySetInnerHTML={{
                      __html: addDofollowToAnchors(item) || "",
                    }}
                  />
                  //   {item}
                  // </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
        <section
          className={`w-full self-stretch flex flex-row items-start justify-end px-6 sm:px-6 lg:px-20 pb-[40px] lg:pb-[60px] box-border text-text-primary max-w-[1600px] mx-auto  ${className}`}
        >
          <div className="w-full self-stretch flex flex-col lg:flex-row items-start justify-start gap-6 md:gap-10 max-w-full shrink-0">
            <div className="w-full lg:w-1/3 flex flex-col items-start justify-start p-0 box-border max-w-full">
              <h2 className="m-0 relative text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] font-medium">
                {t("careers.benefits")}
              </h2>
            </div>
            <div className="w-full flex-1 relative text-[16px] leading-[150%] inline-block max-w-full">
              <ul className="m-0 flex flex-col items-start justify-start gap-3 w-full box-border">
                {benefits?.map((item, i) => (
                  <li
                    key={i}
                    className="w-full relative text-[16px] leading-[150%] text-start wrapListIem"
                    dangerouslySetInnerHTML={{
                      __html: addDofollowToAnchors(item) || "",
                    }}
                  />
                  //   {item}
                  // </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      </>
    );
  }
);

CareerDetails.propTypes = {
  className: PropTypes.string,
};

export default CareerDetails;
